<template>
    <div
        class="detail-question-card"
        :class="{'open-mode': openMode,}"
    >
        <div
            class="indicator"
            :class="{
                'is-right-answer': isRightAnswer,
                'is-wrong-answer': isWrongAnswer,
            }"
        />
        <div class="test-question-card-header" @click.stop="toggleMode">
            <div class="test-question-card-text">
                <div class="question-number">
                    {{ rowNumber }}
                </div>
                <div class="question-header-text" v-html="question.text"></div>
            </div>
        </div>

        <component
            v-if="openMode"
            :is="answerComponent"
            :options="question.variants"
            :is-right="question.is_right"
            :is-interview="question.is_interview"
            :is-has-points="question.is_has_points"
            class="mt-1"
        />
    </div>
</template>

<script>
import StatisticsMultipleChoiceAnswer from "./answers/StatisticsMultipleChoiceAnswer";
import StatisticsSingleChoiceAnswer from "./answers/StatisticsSingleChoiceAnswer";
import StatisticsNumberInputAnswer from "./answers/StatisticsNumberInputAnswer";
import StatisticsTextInputAnswer from "./answers/StatisticsTextInputAnswer";
import TEST_QUESTION_TYPES from "../../../../../const/test-question-types";

const QUESTION_TYPE_ANSWER_COMPONENT_MAP = {
    [TEST_QUESTION_TYPES.SINGLE_CHOICE]: StatisticsSingleChoiceAnswer,
    [TEST_QUESTION_TYPES.MULTIPLE_CHOICE]: StatisticsMultipleChoiceAnswer,
    [TEST_QUESTION_TYPES.NUMBER_INPUT]: StatisticsNumberInputAnswer,
    [TEST_QUESTION_TYPES.TEXT_INPUT]: StatisticsTextInputAnswer,
};

export default {
    name: "StatisticsQuestionCard",
    components: {StatisticsNumberInputAnswer, StatisticsSingleChoiceAnswer, StatisticsMultipleChoiceAnswer},
    props: {
        question: Object,
        rowNumber: Number,
    },
    data() {
        return {
            openMode: true,
        };
    },
    computed: {
        answerComponent() {
            return QUESTION_TYPE_ANSWER_COMPONENT_MAP[this.question.type];
        },
        isRightAnswer() {
            return this.question.is_right && !this.question.is_skip;
        },
        isWrongAnswer() {
            return !this.question.is_interview && !this.question.is_right && !this.question.is_skip
        },
    },
    methods: {
        toggleMode() {
            this.openMode = !this.openMode;
        }
    },
}
</script>

<style lang="scss">
@import 'resources/sass/variables';
.detail-question-card {
    border: 1px solid $tests-light-grey;
    border-radius: 6px;
    font-size: 18px;
    display: flex;
    flex-direction: column;
    padding: 16px 8px 16px 16px;
    position: relative;
    overflow: hidden;

    &:hover:not(.open-mode) {
        border-color: $tests-blue;
        box-shadow: 0 0 9px rgba(131, 131, 131, 0.2);
        cursor: pointer;
        color: $tests-blue;
    }

    .test-question-card-text {
        display: flex;
    }


    .is-answer-wrong {
        background-color: $tests-wrong-answer;
    }

    .is-answer-right {
        background-color: $tests-right-answer;
    }

    // answer
    .test-question-answer-options {
        flex-direction: column;
        width: 100%;
        align-items: stretch;
    }

    .test-question-answer-option-container {
        padding: 17px 15px;
        display: flex;
        justify-content: space-between;

        &:not(:first-child) {
            border-top: 1px solid $tests-light-grey;
        }

        label.radio {
            display: flex;
            text-align: center;

            input[type=radio] {
                min-width: 20px;
                min-height: 20px;
                margin-right: 10px;
                align-self: center;
            }

            span {
                text-align: left;
                word-break: break-word;
            }
        }
    }

    .test-question-answer-container {
        background: #FAFAFA;
        border: 1px solid $tests-light-grey;
        border-radius: 6px;
        width: 100%;
        pointer-events: none;
        overflow: hidden;
    }

    .indicator {
        position: absolute;
        height: 100%;
        width: 8px;
        left: 0;
        top: 0;

        &.is-right-answer {
            background-color: $tests-right-answer;
        }

        &.is-wrong-answer {
            background-color: $tests-wrong-answer;
        }
    }

    .question-number {
        margin-right: 10px;
        font-weight: 600;
    }

    .test-question-card-text {
        overflow: hidden;

        .question-header-text {
            overflow: hidden;
            p {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }

    .test-question-card-header {
        cursor: pointer;
        align-items: flex-start;
    }

    &.open-mode{
        .test-question-card-text {
            overflow: inherit;
            .question-header-text {
                p {
                    overflow: inherit;
                    white-space: normal;
                }
            }
        }

        .test-question-card-header {
            height: auto;
        }
    }
}
</style>